import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import { Toaster } from "./components/ui/toaster";
import { AuthProvider } from "./context/AuthContext";
import { WishlistProvider } from "./context/WishlistContext";
import { WalletProvider } from "./context/WalletContext";
import Home from "./pages/Home";
import Search from "./pages/Search";
import Explore from "./pages/Explore";
import Alerts from "./pages/Alerts";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Pricing from "./pages/Pricing";
import Chat from "./pages/Chat";
import Calendar from "./pages/Calendar";
import Wishlist from "./pages/Wishlist";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import Deal from "./pages/Deal";
import CabinCompare from "./pages/CabinCompare";
import AdminInsights from "./pages/AdminInsights";
import Tracker from "./pages/Tracker";
import WalletPage from "./pages/WalletPage";

function ScrollToTop() {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return null;
}

function App() {
  return (
    <div className="App min-h-screen bg-white">
      <BrowserRouter>
        <AuthProvider>
          <WishlistProvider>
          <WalletProvider>
            <Navbar />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/search" element={<Search />} />
              <Route path="/explore" element={<Explore />} />
              <Route path="/calendar" element={<Calendar />} />
              <Route path="/wishlist" element={<Wishlist />} />
              <Route path="/alerts" element={<Alerts />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/chat" element={<Chat />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
              <Route path="/deal/:id" element={<Deal />} />
              <Route path="/cabin-compare" element={<CabinCompare />} />
              <Route path="/tracker" element={<Tracker />} />
              <Route path="/wallet" element={<WalletPage />} />
              <Route path="/admin/insights" element={<AdminInsights />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            <Footer />
            <Toaster />
          </WalletProvider>
          </WishlistProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
